import SubmitProofTileSvg from '@assets/images/svg/submit-proof-tile.svg';
import React from 'react';
import { View } from 'react-native';

export interface SubmitProofTileIconProps {
    size?: number;
    color?: string;
}

/** Self-contained tile (yellow circle + clock glyph baked in) for the Submit Your Proof screen. */
export function SubmitProofTileIcon({ size = 64, color = '#F57F17' }: Readonly<SubmitProofTileIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <SubmitProofTileSvg width={size} height={size} color={color} />
        </View>
    );
}

export default SubmitProofTileIcon;
